import { cn } from '@core/utils';

import { MyNavigation } from './MyNavigation';

interface MyAsideNavigationLayoutProps {
  children: React.ReactNode;
}

export const MyAsideNavigationLayout = ({
  children,
}: MyAsideNavigationLayoutProps) => {
  return (
    <div
      className={cn(
        'flex flex-1 gap-60 px-40 pt-36 content-container',
        'mobile-tablet:max-w-full mobile-tablet:px-0 mobile-tablet:pt-0',
      )}
    >
      <aside className={cn('shrink-0 basis-160 pb-36', 'mobile-tablet:hidden')}>
        <MyNavigation />
      </aside>
      <div className="flex w-full flex-1 flex-col">{children}</div>
    </div>
  );
};
